module.exports = __webpack_public_path__ + "static/media/angel.a49079ed.png";